<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';

const props = defineProps({
  onClose: { type: Function, required: true },
  label: { type: String, required: true },
});
const frame = ref(null);
let previousFocus;
onMounted(async () => {
  previousFocus = document.activeElement;
  await nextTick();
  frame.value?.querySelector('input,button')?.focus();
});
onBeforeUnmount(() => previousFocus?.isConnected && previousFocus.focus());
function handleKey(event) {
  if (event.key === 'Escape') {
    event.preventDefault();
    event.stopPropagation();
    props.onClose();
  }
  if (event.key !== 'Tab') return;
  const elements = [
    ...frame.value.querySelectorAll(
      'button,input,select,textarea,a[href],[tabindex="0"]'
    ),
  ].filter(element => !element.disabled && element.getClientRects().length);
  const first = elements[0];
  const last = elements.at(-1);
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last?.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first?.focus();
  }
}
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed inset-0 z-[9990] flex items-center justify-center bg-n-alpha-black2 p-2 backdrop-blur-sm sm:p-6"
      @click.self="onClose"
    >
      <section
        ref="frame"
        role="dialog"
        aria-modal="true"
        :aria-label="label"
        class="flex max-h-[94dvh] w-full max-w-5xl flex-col overflow-hidden rounded-2xl border border-n-weak bg-n-solid-1 text-n-slate-12 shadow-2xl"
        @keydown="handleKey"
      >
        <slot />
      </section>
    </div>
  </Teleport>
</template>
